import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {ActivatedRoute} from '@angular/router';
import {ProfessionalLiabilityService} from '../../../../domain/model/liability/professional-liability.service';
import {Malpractice} from '../../../../domain/model/liability/malpractice.model';
import {ProfessionalLiability} from '../../../../domain/model/liability/professional-liability.model';
import {Model} from '../../../../domain/model/common/model.class';
import {FileListComponentModel} from '../../../../components/files/file-list/file-list.component';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {FileListService} from '../../../../components/files/service/file-list.service';
import {FileUploaderComponentModel} from '../../../../components/files/file-uploader/file-uploader.component';
import ProjectionInformation = Model.ProjectionInformation;
import { VerificationService } from '../../../../components/verification/service/verification.service';

@Component({
    template: require('./malpractice-screen.component.html'),
    styles: [require('./malpractice-screen.component.scss')]
})
export class MalpracticeScreenComponent {

    constructor(readonly modelService: ProfessionalLiabilityService,
                readonly route: ActivatedRoute,
                readonly fileListService: FileListService,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {

        this.supportingClaimDocumentUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshSupportingClaimDocumentsInfo());
        this.fileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<ProfessionalLiability>({
        initialDataModel: new ProfessionalLiability(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            this.verificationService.setUrl('professionalLiability', 'section=malpractice');
            return this.modelService.getCurrentUserModel(Malpractice.projectionInformation);
        },
        _submitDataFn: (model: ProfessionalLiability) => {
            return this.modelService.updateCurrentUserModel(model);
        }
    });

    //region Supporting Claim Documents
    get showSupportingClaimDocuments(): boolean {
        return this.model.claim || this.model.monetaryPayment || this.model.pendingClaims;
    }

    supportingClaimDocumentListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('malpracticeSupportingClaimDocument'))
    });

    supportingClaimDocumentUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('malpracticeSupportingClaimDocuments'))
    });

    private _refreshSupportingClaimDocumentsInfo() {
        this.fileListService.list(this.supportingClaimDocumentUploaderModel.filesLocation).subscribe(files => this.supportingClaimDocumentListModel.files = files);
    }

    //endregion

    //region Other Files
    fileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('malpracticeSupportingDocument'))
    });

    fileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('professionalLiability', 'currentUser', new ProjectionInformation('malpracticeSupportingDocuments'))
    });

    private _refreshFilesInfo() {
        this.fileListService.list(this.fileUploaderModel.filesLocation).subscribe(files => this.fileListModel.files = files);
    }

    //endregion

    get model(): Malpractice {
        return this.stepScreenModel.dataModel.malpractice;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/liability/steps/malpractice/malpractice-screen.component.ts